module.exports = __webpack_public_path__ + "static/alchemy-03be256f936449a1cfab619ef435a114.png";